import { Button } from "@maxhub/max-ui"

export const ButtonLinkAsExample = {
    title: 'Button',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [],

    Preview(){
        return (
            <Button
                variant="primary"
                asChild
                size="medium"
            >
                <a
                    href="/"
                    rel="noreferrer"
                    target="_blank"
                >
                    Я — ссылка!
                </a>
            </Button>
        )
    },

    getCode(){
        return `<Button
  variant="primary"
  asChild
  size="medium"
>
  <a
    href="/"
    rel="noreferrer"
    target="_blank"
  >
    Я — ссылка!
  </a>
</Button>`
    }
}